import { Table } from 'components/table'
import { IRecipeExecutionLogDTO } from 'data/dtos/automation/i-recipe-execution-log-dto'
import { ITableHeadDTO } from 'data/dtos/components/i-table-head-dto'
import React, { ChangeEvent, MouseEvent, useEffect, useState } from 'react'
import api from 'services/api'
import { useAlreadyMounted } from 'utils/use-already-mounted'
import { useStyles } from './styles'

const headCells: ITableHeadDTO[] = [
  {
    id: 'recipeName',
    label: 'Receita',
    width: 3,
    type: 'text',
  },
  {
    id: 'executionDateTimeStart',
    label: 'Início Execução',
    width: 2,
    type: 'text',
  },
  {
    id: 'executionDateTimeEnd',
    label: 'Término Execução',
    width: 2,
    type: 'text',
  },
]

const RecipeExecutionLogList: React.FC = () => {
  const [page, setPage] = useState<number>(0)
  const [search, setSearch] = useState<string>('')
  const [rowsCount, setRowsCount] = useState<number>(0)
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const [rowsPerPage, setRowsPerPage] = useState<number>(100)
  const [modalIsOpen, setModalIsOpen] = useState<boolean>(false)
  const [columnOrder, setColumnOrder] = useState<('ASC' | 'DESC')[]>([])
  const [recordToDelete, setRecordToDelete] = useState<string | null>('')
  const [orderByDirection, setOrderByDirection] = useState<boolean>(true)
  const [recipesExecutionLogsList, setRecipesExecutionLogsList] = useState<IRecipeExecutionLogDTO[]>([])

  const classes = useStyles()
  const alreadyMounted = useAlreadyMounted()

  const loadRecipesExecutionLogs = async (isSearch?: boolean) => {
    if (!isSearch) {
      setIsLoading(true)
    }

    await api
      .post('/recipes-execution-logs/list', { search, page, rowsPerPage, columnOrder })
      .then((response) => setRecipesExecutionLogsList(response.data.data))
      .catch((error) => {
        setIsLoading(false)
        console.log(error)
      })

    await api
      .post('/recipes-execution-logs/count', { search })
      .then((response) => setRowsCount(response.data.data.count))
      .catch((error) => {
        setIsLoading(false)
        console.log(error)
      })

    setIsLoading(false)
  }

  const handleDelete = async () => {
    await api
      .delete(`/recipes-execution-logs/${recordToDelete}`)
      .then(async () => await loadRecipesExecutionLogs())
      .catch((error) => console.log(error.response?.data))
  }

  const searchChange = (value: string) => {
    setSearch(value)
  }

  const handleClose = () => {
    setModalIsOpen(false)
  }

  const handleChangePage = (event: MouseEvent<HTMLButtonElement> | null, newPage: number) => {
    event!.preventDefault()
    setPage(newPage)
  }

  const handleChangeRowsPerPage = async (event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setRowsPerPage(parseInt(event.target.value, 10))
    setPage(0)
  }

  const handleCloseDelete = () => {
    setModalIsOpen(false)
    handleDelete()
  }

  const handleDeleteButton = (e: MouseEvent<any, any>, id: string) => {
    e.stopPropagation()
    setModalIsOpen(true)
    setRecordToDelete(id)
  }

  const handleSortChange = (index: number) => {
    columnOrder[index] = columnOrder[index] === 'ASC' ? 'DESC' : 'ASC'

    setColumnOrder(columnOrder)
    setOrderByDirection(!orderByDirection)
  }

  const tabOptions = [
    {
      title: 'Todas',
      size: rowsCount,
      handleClick: () => {},
    },
  ]

  useEffect(() => {
    const timeout = setTimeout(() => {
      if (!alreadyMounted) {
        loadRecipesExecutionLogs()
      }
    }, 1000)

    return () => clearTimeout(timeout)
  }, [search])

  useEffect(() => {
    loadRecipesExecutionLogs()
  }, [orderByDirection, rowsPerPage, page])

  return (
    <Table.Root>
      <Table.Info
        title='Log de Execução de Receitas'
        route='/recipes-execution-logs/new'
        subTitle='Dados coletados sobre os logs de execução das receitas de automação.'
      />

      <Table.tabs options={tabOptions} />
      <Table.SearchBar
        value={search}
        handleChange={searchChange}
      />

      <Table.Overlay
        isEmpty={recipesExecutionLogsList.length <= 0}
        isSearch={search.length > 0}
        isLoading={isLoading}
        route='/recipes-execution-logs/new'
        emptyRouteText='Adicionar recipes_execution_log'
        searchRouteText='Adicionar recipes_execution_log'
        searchMessage='Nenhum recipes_execution_log encontrado, você pode criar um novo recipes_execution_log clicando no botão'
        emptyMessage='Seja bem-vindo à página de gerenciamento de RecipesExecutionLogss. Até o momento, nenhum recipes_execution_log foi criado. Para começar, você pode criar um novo recipes_execution_log clicando no botão'
      >
        <Table.Wrapper
          totalRows={rowsCount}
          handleChangeRowsPerPage={handleChangeRowsPerPage}
          rowsPerPage={rowsPerPage}
          handleChangePage={handleChangePage}
          page={page}
          handleClose={handleClose}
          handleCloseDelete={handleCloseDelete}
          modalIsOpen={modalIsOpen}
        >
          <Table.Header
            handleSortChange={handleSortChange}
            setOrder={setColumnOrder}
            headCells={headCells}
            order={columnOrder}
          />
          <Table.Body
            handleDeleteButton={handleDeleteButton}
            editRoutePath='/recipes-execution-logs/edit'
            headCells={headCells}
            rows={recipesExecutionLogsList}
          />
        </Table.Wrapper>
      </Table.Overlay>
    </Table.Root>
  )
}

export default RecipeExecutionLogList
